module.exports = __webpack_public_path__ + "static/media/redian.17f8ee78.png";